// extracted by mini-css-extract-plugin
export var container = "BackLink-module--container--6948d";
export var link = "BackLink-module--link--d81c5";